import store from '../store/index'

export function buttonPermission(permission) {
    let myButtonPermissions = store.state.buttonPermission;
    return myButtonPermissions.indexOf(permission) > -1;
}